import React from 'react';
import parse from 'html-react-parser';
import { replaceImageBlockFigcaptionStrings } from '../../../model/post';

const Content = ({ content, hasReferences, mainContentMeasureRef, referenceContentRefs }) => {
  let processedReferences = [];

  content = replaceImageBlockFigcaptionStrings(content);

  return (
    <div className="single-article__article-content" ref={mainContentMeasureRef}>
      {!hasReferences && <div dangerouslySetInnerHTML={{ __html: content }} />}
      {hasReferences && (
        <div>
          {parse(content, {
            replace: (domNode) => {

              /**
               * Super script
               */
              if (domNode.name === 'sup') {
                const referenceNumber = domNode.attribs['data-reference-number'];

                if (!referenceNumber) {
                  return;
                }

                const supProps = {
                  className: 'article-reference',
                  id: `ref-${referenceNumber}`,
                };

                if (processedReferences.indexOf(referenceNumber) === -1) {
                  supProps.ref = (ref) => {
                    referenceContentRefs.current[domNode.attribs['data-reference-number']] = ref;
                  };

                  processedReferences.push(referenceNumber);
                }

                function jumpToSidebarRef() {
                  document.getElementById(`reference-item-${referenceNumber}`).scrollIntoView();
                }

                return (
                  <sup {...supProps}>
                    <button onClick={jumpToSidebarRef}>{domNode.children[0].data}</button>
                  </sup>
                );
              }

              /**
               * Image block - add caption to alt text
               */
              if (domNode?.name === 'img' && domNode?.parent?.name === 'figure') {
                let captionText = '';
                const figureCaptionEle = domNode?.parent?.children.find(item => item?.name === 'figcaption');

                if (!figureCaptionEle) {
                  return;
                }

                const { alt, srcset, class: classname, ...restAttrs } = domNode?.attribs;

                if (alt.trim() !== "") {
                  return;
                }

                const captionGrid = figureCaptionEle?.children.find(item =>
                  item?.attribs?.class === 'wp-block-image__caption-grid');

                if (
                  captionGrid &&
                  captionGrid?.children[1] &&
                  captionGrid?.children[1]?.children[0]?.data
                ) {
                  captionText = captionGrid?.children[1]?.children[0]?.data;
                }

                captionText = captionText.trim()

                if (captionText === "") {
                  return;
                }

                const imageProps = {
                  ...restAttrs,
                  srcSet: srcset,
                  className: classname
                };

                return <img {...imageProps} alt={captionText} />
              }
            },
          })}
        </div>
      )}
    </div>
  );
};

export default Content;
